// import { useEffect, useState } from "react";

// function useNetworkStatus() {
//   const [isOnline, setIsOnline] = useState(navigator.onLine); // Default to navigator.onLine
//   const [networkType, setNetworkType] = useState("UNKNOWN");

//   useEffect(() => {
//     const updateOnlineStatus = () => {
//       setIsOnline(navigator.onLine);
//     };

//     window.addEventListener("online", updateOnlineStatus);
//     window.addEventListener("offline", updateOnlineStatus);

//     return () => {
//       window.removeEventListener("online", updateOnlineStatus);
//       window.removeEventListener("offline", updateOnlineStatus);
//     };
//   }, []);

//   useEffect(() => {
//     if (window.tizen) {
//       try {
//         window.tizen.systeminfo.getPropertyValue(
//           "NETWORK",
//           (network) => {
//             const type = network.networkType || "NONE";
//             setNetworkType(type);
//           },
//           (error) => {
//             console.error("Error fetching network type:", error);
//           }
//         );
//       } catch (error) {
//         console.error("Error accessing tizen systeminfo:", error);
//       }
//     }
//   }, [isOnline]);

//   return { isOnline, networkType };
// }


// export default useNetworkStatus;


import { useEffect, useState } from "react";
 
function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [networkType, setNetworkType] = useState("UNKNOWN");
 

  
  useEffect(() => {
    let listenerId = null;
 
    // Fallback for online/offline (rarely fires on Samsung TV)
    const handleOnlineStatus = () => setIsOnline(navigator.onLine);
 
    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);
 
    // Tizen: REAL listener for network change
    if (window.tizen?.systeminfo) {
      listenerId = window.tizen.systeminfo.addPropertyValueChangeListener(
        "NETWORK",
        (network) => {
          const type = network.networkType || "NONE";
 
          setNetworkType(type);
          setIsOnline(type !== "NONE"); // updates automatically when network returns
        }
      );
    }
 
    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
 
      if (listenerId && window.tizen?.systeminfo) {
        window.tizen.systeminfo.removePropertyValueChangeListener(listenerId);
      }
    };
  }, []);
 
  return { isOnline, networkType };
}
 
export default useNetworkStatus;